import React, { Component } from 'react';

import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';

import Loader from '../components/Loader';

class LoginView extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      email: '',
      password: '',
      attempts: 0,
    };
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  isFormValid() {
    return this.state.email.length > 0 && this.state.password.length > 0 && 
      this.isValidEmail(this.state.email);   
  } 

  isValidEmail(email) {
    let regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regex.test(String(email).toLowerCase());
  }

  handleEmailChange(event) {
    this.setState({ email: event.target.value });
  } 

  handlePasswordChange(event) {  
    this.setState({ password: event.target.value });
  }

  handleSubmit(event) {
    // TODO handleSubmit should be called when ENTER is pressed.
    event.preventDefault();
    this.setState({ attempts: this.state.attempts + 1 });
    this.props.store.login(this.state.email, this.state.password);
  }

  render() {
    const { store } = this.props;
    const processing = store.processingLogin.get()
    return (
      <div className="container">
        {(this.state.attempts > 0 && !processing) &&
          <div className="row">
            <div className="col-md-6 text-left">
              <div className="alert alert-danger" role="alert">
                The email and password you entered did not match our records. Please double-check and try again.
              </div>
            </div>
          </div>
        }
        <div className="row">
          <div className="col-md-3"></div>
          <div className="col-md-6">
            <br />
            <div className="text-center">
              <img
                alt="" 
                src="https://my.kabbalah.com/ticket-widget/media/logo.svg"             
                width="80%"
              /> 
            </div> 
            <br />   
            <br />   
            <p className="text-muted">Please log in with your Kabbalah.com credentials.</p>  
            <form onSubmit={this.handleSubmit}>     
              <div className="form-group">
                <label htmlFor="exampleInputEmail1">EMAIL</label>
                <input 
                  type="email" 
                  className="form-control" 
                  placeholder="Email" 
                  value={this.state.email} 
                  onChange={this.handleEmailChange} 
                />
              </div>
              <div className="form-group">
                <label htmlFor="password">PASSWORD</label>
                <input 
                  type="password" 
                  className="form-control"                 
                  placeholder="Password" 
                  value={this.state.password} 
                  onChange={this.handlePasswordChange} 
                />
              </div>
              {!processing &&
                <button 
                  type="submit" 
                  className="btn btn-block btn-danger" 
                  onSubmit={this.handleSubmit}
                  disabled={!this.isFormValid() || store.processingLogin.get()}
                >
                  Log In                
                </button>	  
              }  
              {processing && 
                <button 
                  className="btn btn-block btn-outline-danger" 
                  disabled
                >
                  Logging in... <Loader />             
                </button>	             
              }   
            </form>     
          </div>
          <div className="col-md-3"></div>
        </div>
      </div>
    );
  }

}

export default withRouter(inject('store')(observer(LoginView)));



// WEBPACK FOOTER //
// ./src/views/LoginView.js